import type { TraversalState } from '../types/levelEditor';

export const MIN_TRAVERSAL_BRUSH_SIZE = 1;
export const MAX_TRAVERSAL_BRUSH_SIZE = 12;
export const DEFAULT_TRAVERSAL_BRUSH_SIZE = 1;
export const DEFAULT_TRAVERSAL_PAINT_STATE: TraversalState = 'blocked';

export interface TraversalBrushBounds {
  endX: number;
  endY: number;
  startX: number;
  startY: number;
  width: number;
  height: number;
}

export const clampTraversalBrushSize = (size: number): number =>
  Math.min(MAX_TRAVERSAL_BRUSH_SIZE, Math.max(MIN_TRAVERSAL_BRUSH_SIZE, Math.round(size)));

export const getTraversalBrushBounds = (input: {
  mapSize?: number;
  canvasWidth?: number;
  canvasHeight?: number;
  size: number;
  x: number;
  y: number;
}): TraversalBrushBounds => {
  const size = clampTraversalBrushSize(input.size);
  const canvasWidth = Math.max(
    1,
    Math.floor(input.canvasWidth ?? input.mapSize ?? input.canvasHeight ?? 1),
  );
  const canvasHeight = Math.max(
    1,
    Math.floor(input.canvasHeight ?? input.mapSize ?? input.canvasWidth ?? 1),
  );
  const startX = Math.max(0, input.x - Math.floor(size / 2));
  const startY = Math.max(0, input.y - Math.floor(size / 2));
  const endX = Math.min(canvasWidth - 1, startX + size - 1);
  const endY = Math.min(canvasHeight - 1, startY + size - 1);

  return {
    endX,
    endY,
    startX,
    startY,
    width: endX - startX + 1,
    height: endY - startY + 1,
  };
};
